import PropTypes from 'prop-types';
import React, {Component} from 'react';

import Spinner from 'components/Spinner';

import {FormButton, FormButtonLink} from './styles';

class FormButtonBase extends Component {
  static propTypes = {
    device: PropTypes.oneOf(['desktop', 'mobile']).isRequired,
    isInverse: PropTypes.bool,
    isLink: PropTypes.bool,
    isLoading: PropTypes.bool
  };

  render() {
    const {children, device, isInverse, isLink, isLoading, ...forwardedProps} = this.props;
    const RootComponent = isLink ? FormButtonLink : FormButton;

    return (
      <RootComponent device={device} isInverse={isInverse} {...forwardedProps}>
        {isLoading ? <Spinner centerY size="1rem" /> : children}
      </RootComponent>
    );
  }
}

export const FormButtonDesktop = props => <FormButtonBase device="desktop" {...props} />;
export const FormButtonMobile = props => <FormButtonBase device="mobile" {...props} />;
